import axios from '../../utils/axios2'
import queryString from '@/utils/queryString';
export default {

    namespaced: true,

    state: {
        mileageReading: null,
        mileageReadings: []
    },

    mutations: {
        setMileageReading(state, payload) {
            state.mileageReading = payload;
        },
        setMileageReadings(state, payload) {
            state.mileageReadings = payload;
        }
    },

    actions: {
        storeMileageReading({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: "mileage-readings",
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                })
            });
        },
        updateMileageReading({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `mileage-readings/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                })
            });
        },
        fetchMileageReading({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `mileage-readings/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    commit('setMileageReading', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                })
            });
        },
        fetchMileageReadings({commit, rootState}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `mileage-readings?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    commit('setMileageReadings', response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                })
            });
        },
        removeMileageReading({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `mileage-readings/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                })
            });
        },
        restTrucks({commit}) {
            commit('restTrucks');
        },
    }

}